"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const aria_1 = require("../Form/Inputs/utils/aria");
const Loading_1 = require("../Loading");
const buttonStyle = (0, app_1.css) `
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: top;
  min-width: 6em;
  height: 2.25em;
  border-radius: 0.25em;
  padding: 0 ${(theme) => theme.spacing.small};
  ${app_1.styled.disabled `
    cursor: default;
    pointer-events: none;
  `}
`;
const StyledButtonLoading = (0, app_1.styled)(Loading_1.Loading) `
  font-size: 1.5em;
  padding: 1rem;
`;
const StyledButton = app_1.styled.button(buttonStyle);
const StyledLink = (0, app_1.styled)(app_1.Link)(buttonStyle);
exports.Button = (0, react_1.forwardRef)((_a, ref) => {
    var { children, kind = [], type = 'button', href, download, loading, disabled } = _a, props = __rest(_a, ["children", "kind", "type", "href", "download", "loading", "disabled"]);
    const isLink = type === 'button' && href;
    const Render = isLink
        ? StyledLink
        : StyledButton;
    const style = (0, react_1.useMemo)(() => {
        const kinds = Array.isArray(kind) ? kind : [kind];
        return (0, app_1.css) `
        ${({ buttons }) => [buttons.css, ...kinds.map((k) => buttons[k])]}
      `;
    }, [kind]);
    return ((0, jsx_runtime_1.jsx)(Render, Object.assign({}, props, { ref: ref, type: type }, (isLink ? { kind: 'box', href, download } : {}), (0, aria_1.aria)({ disabled: Boolean(loading !== null && loading !== void 0 ? loading : disabled) }), { disabled: loading || disabled, css: style }, { children: loading ? (0, jsx_runtime_1.jsx)(StyledButtonLoading, {}) : children })));
});
